import React, { Suspense } from 'react';

import { useQueryMe } from 'gql/queries/me';

const Migrations = React.lazy(() => import('./Migrations'));

const MigrationsContainer = () => {
  const { isLoading, data } = useQueryMe();
  const shouldFillSector = isLoading
    ? false
    : data.me.tags.includes('onboarded') &&
      !['lower', 'higher', 'business'].includes(data.me.sector);
  const shouldFillRole = isLoading
    ? false
    : data.me.tags.includes('onboarded') &&
      !['student', 'teacher'].includes(data.me.role);
  return !shouldFillRole && !shouldFillSector ? null : (
    <Suspense fallback={null}>
      <Migrations
        me={data.me}
        shouldFillRole={shouldFillRole}
        shouldFillSector={shouldFillSector}
      />
    </Suspense>
  );
};

export default MigrationsContainer;
